import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=06ed3558&scoped=true&"
import script from "./Header.vue?vue&type=script&lang=js&"
export * from "./Header.vue?vue&type=script&lang=js&"
import style0 from "./Header.vue?vue&type=style&index=0&id=06ed3558&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ed3558",
  null
  
)


    import installComponents from "!/Users/leandrosehnembortolotto/Development/Dropsmart/dropsmith-frontend-v2/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BNavItem, BNavbarNav, BNavbar} from 'bootstrap-vue'
    installComponents(component, {BNavItem, BNavbarNav, BNavbar})
    

export default component.exports